<template>
  <b-container>
    <div class="mb-2">
      <h4>Selecciona el proyecto donde quieres cotizar</h4>
      <b-form-select v-model="projectId" :options="projects" @change="reload">
        <template #first>
          <b-form-select-option :value="null" disabled
            >Por favor selecciona una opción</b-form-select-option
          >
        </template>
      </b-form-select>
    </div>
    <div
      v-if="customer == 'clab'"
      id="iframe"
      style="max-height: 750px; height: 100vh"
    ></div>
    <div v-else id="widget"></div>
  </b-container>
</template>
<script>
export default {
  name: "quote",
  data() {
    return {
      projectId: null,
      showQuote: false,
      quoteWidget: null,
    };
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
    gcVersion() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.gc_version
        : 1;
    },
    projects() {
      if (this.$store.getters.getProjects) {
        return this.$store.getters.getProjects.reduce(function (
          newData,
          project
        ) {
          if (project.activoCotizadorWeb) {
            if (project.nombreProyecto != "Marcha Blanca") {
              newData.push({ value: project.id, text: project.nombreProyecto });
            }
          }
          return newData;
        },
        []);
      } else {
        return null;
      }
    },
  },
  methods: {
    reload() {
      if (document.getElementById("widget")) {
        document.getElementById("widget").innerHTML = "";
        let self = this;
        setTimeout(function () {
          document.getElementById("widget").innerHTML = self.projectId
            ? `<mobysuite-quote real-estate="${self.customer}" project-id="${self.projectId}" version="${self.gcVersion}"><mobysuite-quote>`
            : (self.quoteWidget = null);
          let script = document.createElement("script");
          script.src = "https://cdn.mobysuite.com/quote/js/app.js";
          document.getElementById("widget").appendChild(script);
        }, 1000);
      } else {
        document.getElementById("iframe").innerHTML =
          "<iframe src='https://collectivelab.cl/producto-id-" +
          this.projectId +
          "' style='width: 100%; max-height: 750px; height: 100vh; border: none'>";
      }
    },
  },
};
</script>
